export const familyLifeMinistryId = '9f63db46-6ca9-43b0-868a-23326b3c4d91';
export const aiaMinistryId = '87b02878-5070-473b-bb07-3b2d899b46d6';
export const wtrActivityId = '9c6eae3f-8928-4703-a2a4-e5bf995dfd19';
